<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="form-container">
    <div class="header-cont">
      <CircularButton
        class="back-btn"
        icon="long-arrow-alt-left"
        color="#0000"
        @click="goBack()"
      />
      <h2>Pet Settings</h2>
    </div>
    <div class="profile-image">
      <img :src="image" alt="Profile Image" style="width: 100%" />
      <div class="photo-uploader">
        <label for="profile-image-uploader">
          <fa id="upload-icon" icon="upload" />
        </label>
        <input
          type="file"
          id="profile-image-uploader"
          @change="handleFileUpload"
        />
      </div>
    </div>
    <form @submit.prevent="updatePetInfo">
      <div class="input-field">
        <label for="name"><fa class="icon" icon="info" /> Name</label>
        <input
          required
          type="text"
          placeholder="Name"
          name="name"
          v-model="formData.name"
        />
      </div>
      <div class="input-field">
        <label for="type"><fa class="icon" icon="info" /> Type</label>
        <select name="type" v-model="formData.type">
          <option value="" selected disabled>
            Select {{ formData.name }}'s Type
          </option>
          <option value="Dog">Dog</option>
          <option value="Cat">Cat</option>
          <option value="Other">Other</option>
        </select>
      </div>
      <div
        class="input-field"
        :style="
          formData.type == 'Dog' || formData.type == 'Cat'
            ? 'display: flex'
            : 'display: none'
        "
      >
        <label for="breed"><fa class="icon" icon="info" /> Breed</label>

        <select
          name="breed"
          v-model="formData.breed"
          :style="formData.type == 'Dog' ? 'display: block' : 'display: none'"
        >
          <option value="" selected disabled>
            Select {{ formData.name }}'s Breed
          </option>
          <optgroup name="retriever" label="Retriever">
            <option value="Golden">Golden</option>
            <option value="Labrador">Labrador</option>
          </optgroup>
          <optgroup name="shepherd" label="Shepherd">
            <option value="Greek_Shepherd">Greek</option>
            <option value="German_Shepherd">German</option>
            <option value="Australian_Shepherd">Australian</option>
          </optgroup>
          <option value="Goldendoodle">Goldendoodle</option>
          <option value="Chihuahua">Chihuahua</option>
          <optgroup name="terrier" label="Terrier">
            <option value="Yorkshire">Yorkshire</option>
            <option value="American_Pit_Bull">American Pit Bull</option>
          </optgroup>
          <optgroup name="husky" label="Husky">
            <option value="Siberian_Husky">Siberian</option>
          </optgroup>
          <option value="Dachshund">Dachshund</option>
          <option value="Shih_Tzu">Shih Tzu</option>
          <optgroup name="bulldog" label="Bulldog">
            <option value="French_Bulldog">French</option>
          </optgroup>
          <option value="Boxer">Boxer</option>
          <option value="Labradoodle">Labradoodle</option>
          <option value="Beagle">Beagle</option>
          <option value="Maltese">Maltese</option>
          <option value="Poodle">Poodle</option>
          <option value="Pomeranian">Pomeranian</option>
          <option value="Pug">Pug</option>
          <option value="Shiba_Inu">Shiba Inu</option>
          <option value="Other">Other</option>
        </select>

        <select
          name="breed"
          v-model="formData.breed"
          :style="formData.type == 'Cat' ? 'display: block' : 'display: none'"
        >
          <option value="" selected disabled>
            Select {{ formData.name }}'s Breed
          </option>
          <option value="Ragdoll">Ragdoll</option>
          <option value="Exotic">Exotic</option>
          <option value="Maine_Coon_Cat">Maine Coon Cat</option>
          <option value="Persian">Persian</option>
          <option value="British_Shorthair">British Shorthair</option>
          <option value="Devon_Rex">Devon Rex</option>
          <option value="Abyssinian">Abyssinian</option>
          <option value="American_Shorthair">American Shorthair</option>
          <option value="Scottish_Fold">Scottish Fold</option>
          <option value="Sphynx">Sphynx</option>
          <option value="Other">Other</option>
        </select>
      </div>
      <div class="input-field">
        <label for="age"
          ><fa class="icon" icon="info" /> Age: <b>{{ formData.age }}</b></label
        >
        <input
          required
          type="range"
          placeholder="Age"
          name="age"
          min="0"
          max="20"
          v-model="formData.age"
        />
      </div>
      <div class="input-field">
        <label for="gender"><fa class="icon" icon="info" /> Gender</label>
        <select name="gender" v-model="formData.gender">
          <option value="" selected disabled>
            Select {{ formData.name }}'s Gender
          </option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
      <div class="input-field">
        <label for="behaviour"><fa class="icon" icon="info" /> Behaviour</label>
        <select name="behaviour" v-model="formData.behaviour">
          <option value="" selected disabled>
            Select {{ formData.behaviour }}'s Behaviour
          </option>
          <option value="Friendly">Friendly</option>
          <option value="Normal">Normal</option>
          <option value="Not_so_friendly">Not so friendly</option>
          <option value="Fearful/Shy">Fearful/Shy</option>
        </select>
      </div>
      <div class="input-field">
        <label for="size"><fa class="icon" icon="info" /> Size</label>
        <select name="size" v-model="formData.size">
          <option value="" selected disabled>
            Select {{ formData.size }}'s Size
          </option>
          <option value="Small">Small</option>
          <option value="Medium">Medium</option>
          <option value="Large">Large</option>
        </select>
      </div>
      <Button text="Save Changes" color="#454545" />
    </form>
    <h3>Danger Zone</h3>
    <!-- <div class="input-field"> -->
    <div class="del-account-cont">
      <p>Delete Pet</p>
      <Button text="Delete" color="var(--danger)" @click="deletePet" />
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Button from "@/components/Button.vue";
import CircularButton from "@/components/CircularButton.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";

let allowedFileExtensions = ["jpg", "png", "jpeg"];
let jwt;

let headers = {};

export default {
  components: { Navbar, Button, CircularButton, LoadingScreen },
  name: "EditPet",
  data() {
    return {
      petID: "",
      formData: {
        name: "",
        type: "",
        breed: "",
        age: "",
        gender: "",
        behaviour: "",
        size: "",
      },
      formDataCopy: {
        name: "",
        type: "",
        breed: "",
        age: "",
        gender: "",
        behaviour: "",
        size: "",
      },
      image: "",
      owner: "",
      catOptions: {},
      dogOptions: {},
    };
  },
  methods: {
    handleFileUpload(event) {
      let self = this;

      // VALIDATE THE FILE
      let splitFilename = event.target.files[0].name.split(".");
      let fileExtension = splitFilename[splitFilename.length - 1];
      // console.log(fileExtension);
      // IF THE FILE IS OF AN UNSUPPORTED TYPE, RETURN WHILE THROWING AN ERROR
      if (!allowedFileExtensions.includes(fileExtension)) {
        Swal.fire(
          "Error",
          "The file you uploaded is not supported. Try uploading a file with a valid extension. <br/><b>Valid extensions:</b> " +
            allowedFileExtensions,
          "error"
        );
        return;
      }

      self.imageFile = event.target.files[0];
      Swal.fire({
        title: "Upload Image?",
        html: "You have uploaded a file: <b>" + self.imageFile.name + "</b>",
        icon: "question",
        showCancelButton: true,
        // cancelButtonColor: "#CC2200",
        confirmButtonText: "Upload",
      }).then((res) => {
        if (res.isConfirmed) {
          this.submitImage();
        }
      });
    },
    submitImage() {
      let formData = new FormData();
      formData.append("file", this.imageFile);
      // console.log(formData);
      let self = this;

      let jwt = localStorage.getItem("jwt");
      if (jwt == null) {
        Swal.fire(
          "An error occured!",
          "Please refresh the page.",
          "error"
        ).then((res) => {
          if (res.isConfirmed) {
            self.$router.push("/");
          }
        });
      }

      axios
        .post(
          `${process.env.VUE_APP_BACKEND}/pets/${this.petID}/image/upload`,
          formData,
          {
            headers: headers,
          }
        )
        .then(() => {
          Swal.fire(
            "Uploaded new file",
            "Your new image has been uploaded successfully.",
            "success"
          ).then(() => {
            self.$router.go();
          });
        });
    },
    updatePetInfo() {
      if (
        this.formData.name != this.formDataCopy.name ||
        this.formData.type != this.formDataCopy.type ||
        this.formData.breed != this.formDataCopy.breed ||
        this.formData.age != this.formDataCopy.age ||
        this.formData.gender != this.formDataCopy.gender ||
        this.formData.behaviour != this.formDataCopy.behaviour ||
        this.formData.size != this.formDataCopy.size
      ) {
        let data = {};
        data.pet = {};
        if (this.formData.name != this.formDataCopy.name) {
          data.pet.name = this.formData.name;
        }
        if (this.formData.type != this.formDataCopy.type) {
          data.pet.type = this.formData.type;
        }
        if (this.formData.breed != this.formDataCopy.breed) {
          data.pet.breed = this.formData.breed;
        }
        if (this.formData.age != this.formDataCopy.age) {
          data.pet.age = this.formData.age;
        }
        if (this.formData.gender != this.formDataCopy.gender) {
          data.pet.gender = this.formData.gender;
        }
        if (this.formData.behaviour != this.formDataCopy.behaviour) {
          data.pet.behaviour = this.formData.behaviour;
        }
        if (this.formData.size != this.formDataCopy.size) {
          data.pet.size = this.formData.size;
        }
        // console.log(data);
        headers["content-type"] = "application/json";
        // // console.log(headers);
        axios
          .put(`${process.env.VUE_APP_BACKEND}/pets/${this.petID}`, data, {
            headers: headers,
          })
          .then(function () {
            Swal.fire(
              "Success",
              `${data.pet.name}'s information were updated successfully!`,
              "success"
            );
          })
          .catch(function (err) {
            Swal.fire(
              "An error occurred",
              `${data.pet.name}'s information were not updated! Error: ${err}`,
              "err"
            );
          });
      }
    },
    deletePet() {
      headers["content-type"] = "";
      let self = this;
      Swal.fire({
        title: `Are you sure you want to delete ${self.formData.name}'s profile?`,
        text: `This process is going to delete all of ${self.formData.name}'s data and is irreversible.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#4285f4",
        cancelButtonColor: "#ff3018",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log(data);
          axios
            .delete(`${process.env.VUE_APP_BACKEND}/pets/${self.petID}`, {
              headers: headers,
            })
            .then(function () {
              // console.log(res);
              Swal.fire({
                title: "Success",
                text: `${self.formData.name}'s data were erased successfully!`,
                icon: "success",
              }).then(() => {
                self.$router.push("/profile");
              });
            })
            .catch(function (err) {
              // console.log(err);
              Swal.fire({
                title: "An error occured!",
                text: `An error occured while deleting ${self.formData.name}'s data. <br>Server's response: ${err}`,
                icon: "error",
              });
            });
        }
      });
    },
    goBack() {
      let self = this;
      self.$router.go(-1);
    },
  },
  mounted() {
    let title = "Edit Pet - Dating4Pets";
    document.title = title;

    let self = this;
    jwt = localStorage.getItem("jwt");
    if (jwt == null) {
      self.$router.push("/");
    }

    const query = window.location.search;
    const getParameters = new URLSearchParams(query);

    this.petID = getParameters.get("id");

    if (this.petID == null) {
      // console.log("Empty id");
      self.$router.push("/");
    }

    headers = {
      Authorization: "Bearer " + jwt,
      "content-type": "multipart/form-data",
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/pets/${this.petID}/info`, {
        headers: headers,
      })
      .then(function (res) {
        // console.log(res);
        self.formData.name = res.data.pet.name;
        self.formData.type = res.data.pet.type;
        self.formData.breed = res.data.pet.breed;
        self.formData.age = res.data.pet.age;
        self.formData.gender = res.data.pet.gender;
        self.formData.behaviour = res.data.pet.behaviour;
        self.formData.size = res.data.pet.size;

        self.formDataCopy.name = self.formData.name;
        self.formDataCopy.type = self.formData.type;
        self.formDataCopy.breed = self.formData.breed;
        self.formDataCopy.age = self.formData.age;
        self.formDataCopy.gender = self.formData.gender;
        self.formDataCopy.behaviour = self.formData.behaviour;
        self.formDataCopy.size = self.formData.size;

        axios
          .get(`${process.env.VUE_APP_BACKEND}/pets/images/${self.petID}`, {
            headers: headers,
          })
          .then(function () {
            self.image = `${process.env.VUE_APP_BACKEND}/pets/images/${self.petID}`;
          })
          .catch(() => {
            self.image = "/paw.svg";
          });

        self.owner = res.data.user;

        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);
      })
      .catch((err) => {
        // console.log(err.response.data.statusCode);
        if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          self.$router.push("/");
        } else {
          Swal.fire("Error", `${err}`, "error");
        }
      });
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: initial;
  color: var(--dark-clr);
  width: 90%;
  max-width: 50rem;
  height: 80%;
  margin: 1rem;
  padding: 2rem;
  position: relative;
  background: white;
  box-shadow: 0 0.1rem 1rem 0.2rem rgba(126, 126, 126, 0.3);
  border-radius: 1rem;
  margin: auto;
  margin-block-start: 7em;
}

form {
  display: flex;
  flex-direction: column;
  /* height: 100%; */
  justify-content: center;
  align-items: center;

  padding-block: 2em;
  /* padding-inline: 1.5em; */
  gap: var(--gap);
  z-index: 100;
  width: 100%;
  overflow: visible;
}

#form-logo {
  width: 50%;
  aspect-ratio: 1;
}

p {
  color: var(--dark-clr);
}
a {
  text-decoration: none;
}
h2 {
  margin-block: 1em;
}
.form-link {
  color: var(--primary-clr);
  transition: 0.5s ease;
}
.form-link:hover,
.form-link:focus {
  color: var(--dark-clr);
}

.input-field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: visible;
  /* width: 60%; */
  /* width: 80%; */
  width: 70%;
  position: relative;
}

.input-field > input,
select {
  height: 2rem;
  min-width: 15em;
  width: 70%;
  max-width: 20em;
  background: white;
  color: var(--dark-clr);
  border-radius: 2rem;
  padding: 0.2rem 1rem;
  margin: 0.2rem;
  /* margin-inline-start: auto; */
  border: none;
  box-shadow: var(--box-shadow);
  font-weight: bold;
  transition: 0.5s ease;
}

select {
  cursor: pointer;
}

.input-field > input::placeholder {
  color: var(--mid-dark-clr);
}

.input-field > input:focus {
  border: none;
  box-shadow: var(--box-shadow-focus);
}

.input-field > label .icon {
  /* color: var(--icon-color); */
  color: var(--primary-clr);
  /* margin: 0 0.5rem; */
  width: 16px;
  height: 16px;
}

.input-field > label {
  min-width: 4em;
  width: 100%;
  max-width: 10em;
}

.input-field > label {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: var(--gap);
}

.input-field > input:disabled {
  background: rgb(220, 220, 220);
  box-shadow: none;
}

.message {
  position: absolute;
  right: 0;
  top: -80%;
  /* background: black; */
  /* color: white; */
  height: 2em;
  padding-inline: 0.5em;
  border-radius: 15em;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: var(--light-box-shadow);
  opacity: 0;
  transition: var(--transition);
}
/* .input-field label {
  display: none;
} */

input:disabled:hover + .message {
  opacity: 1;
}

.profile-image {
  background: #0000;
  border-radius: 50%;
  min-width: 10em;
  width: 10%;
  max-width: 30em;
  aspect-ratio: 1;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  top: 15%;
  z-index: 1000;
  box-shadow: var(--light-box-shadow);
}

input[type="file"] {
  /* display: none; */
  display: block;
  width: 100%;
  opacity: 0;
  position: absolute;
  height: 100%;
  cursor: pointer;
}

.photo-uploader:hover,
.photo-uploader:focus {
  opacity: 1;
}

.profile-image:hover {
  box-shadow: var(--box-shadow-focus);
}

#upload-icon {
  width: 30%;
  height: 30%;
  color: var(--light-clr);
  /* margin: auto; */
}

.del-account-cont {
  display: flex;
  align-items: center;
  gap: var(--gap);
  overflow: visible;
  margin-block: 2em;
  width: 70%;
}

.back-btn {
  position: absolute;
  left: calc(0% + 2em);
  top: calc(0% + 3em);
  animation-name: playfullCallToAction;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transition: var(--transition);
}

.header-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.show-pass {
  position: absolute;
  right: calc(0% + 1em);
  cursor: pointer;
}
.show-pass > .icon {
  color: var(--primary-clr);
}
.show-pass:hover > .icon {
  color: var(--mid-dark-clr);
}

@media screen and (max-width: 30rem) {
  .form-container {
    margin: 1rem;
  }
  .back-btn {
    position: relative;
    left: 0;
    top: 0;
  }
}

@media screen and (max-width: 35rem) {
  .input-field {
    flex-direction: column;
  }
  .input-field label {
    margin-block: 1em 0.5em;
    /* width: 75%;
    justify-content: space-between; */
    align-self: flex-start;
  }
}

@media screen and (max-width: 54rem) {
  .input-field {
    justify-content: center;
  }
  .del-account-cont {
    width: 100%;
  }
  .back-btn {
    margin-block-start: 3em;
  }
  .input-field > label {
    font-size: 0.8rem;
  }
}

/* @media (hover: none) {
  .edit-pet {
    display: flex;
  }
} */
</style>
